// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html, body, #root {
  margin: 0;
  padding: 0;
  min-height: 100%;
  width: 100%;
}

html,
body {
  overflow-x: hidden;
}

body {
  font-family: "DM Sans", sans-serif;
}

img,
svg,
canvas,
video {
  max-width: 100%;
  height: auto;
}

option {
  color: black;
}

/* Media Queries Globales para Responsividad */

/* Mobile First - Dispositivos pequeños (móviles) */
@media (max-width: 480px) {
  body {
    font-size: 14px;
  }

  * {
    scroll-behavior: auto;
  }
}

/* Tablets pequeñas */
@media (max-width: 768px) {
  body {
    font-size: 15px;
  }
}

/* Tablets grandes y superiores */
@media (min-width: 769px) {
  body {
    font-size: 16px;
  }
}

/* Estilos responsivos para tablas */
table {
  width: 100%;
  border-collapse: collapse;
}

@media (max-width: 768px) {
  table {
    font-size: 12px;
  }

  table th,
  table td {
    padding: 8px 6px;
  }
}

/* Estilos responsivos para formularios */
input,
select,
textarea {
  width: 100%;
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: "DM Sans", sans-serif;
}

@media (max-width: 768px) {
  input,
  select,
  textarea {
    padding: 8px;
    font-size: 16px;
  }
}

/* Editores de texto enriquecido: el tema snow escribe a 13px, demasiado pequeño
   para revisar una descripción. Las vistas con alto propio siguen mandando. */
.ql-editor {
  min-height: 130px;
  font-size: 15px;
  line-height: 1.6;
}

/* Scrollbar personalizada */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

[role="dialog"] {
  max-width: calc(100vw - 24px);
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Asegurar que los elementos flex sean responsivos */
@media (max-width: 768px) {
  [role="button"] {
    min-height: 44px;
    min-width: 44px;
  }
}

/* ---- Modo noche (Chakra pone body.chakra-ui-dark) ---------------------------------- */

/* Campos de fecha, barras de desplazamiento y listas nativas en oscuro. */
body.chakra-ui-dark {
  color-scheme: dark;
}

body.chakra-ui-dark option {
  color: #ffffff;
  background-color: #111c44;
}

body.chakra-ui-dark ::-webkit-scrollbar-thumb {
  background: #3b4a7a;
}

body.chakra-ui-dark ::-webkit-scrollbar-thumb:hover {
  background: #4f5f94;
}

/* Editor de texto enriquecido (Quill, tema snow): iconos y bordes claros sobre oscuro. */
body.chakra-ui-dark .ql-toolbar.ql-snow,
body.chakra-ui-dark .ql-container.ql-snow {
  border-color: rgba(255, 255, 255, 0.16);
}

body.chakra-ui-dark .ql-snow .ql-stroke {
  stroke: #ffffff;
}

body.chakra-ui-dark .ql-snow .ql-fill,
body.chakra-ui-dark .ql-snow .ql-stroke.ql-fill {
  fill: #ffffff;
}

body.chakra-ui-dark .ql-snow .ql-picker {
  color: #ffffff;
}

body.chakra-ui-dark .ql-snow .ql-picker-options {
  background-color: #111c44;
  border-color: rgba(255, 255, 255, 0.16);
}

body.chakra-ui-dark .ql-snow.ql-toolbar button:hover .ql-stroke,
body.chakra-ui-dark .ql-snow.ql-toolbar button.ql-active .ql-stroke,
body.chakra-ui-dark .ql-snow .ql-picker-label:hover .ql-stroke {
  stroke: #ffffff;
}

body.chakra-ui-dark .ql-editor.ql-blank::before {
  color: rgba(255, 255, 255, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;EAIE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,8CAA8C;;AAE9C,mDAAmD;AACnD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;;;EAGE,WAAW;EACX,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;;;IAGE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;8EAC8E;AAC9E;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,yFAAyF;;AAEzF,0EAA0E;AAC1E;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yFAAyF;AACzF;;EAEE,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  width: 100%;\n}\n\nhtml,\nbody {\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: \"DM Sans\", sans-serif;\n}\n\nimg,\nsvg,\ncanvas,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\noption {\n  color: black;\n}\n\n/* Media Queries Globales para Responsividad */\n\n/* Mobile First - Dispositivos pequeños (móviles) */\n@media (max-width: 480px) {\n  body {\n    font-size: 14px;\n  }\n\n  * {\n    scroll-behavior: auto;\n  }\n}\n\n/* Tablets pequeñas */\n@media (max-width: 768px) {\n  body {\n    font-size: 15px;\n  }\n}\n\n/* Tablets grandes y superiores */\n@media (min-width: 769px) {\n  body {\n    font-size: 16px;\n  }\n}\n\n/* Estilos responsivos para tablas */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n@media (max-width: 768px) {\n  table {\n    font-size: 12px;\n  }\n\n  table th,\n  table td {\n    padding: 8px 6px;\n  }\n}\n\n/* Estilos responsivos para formularios */\ninput,\nselect,\ntextarea {\n  width: 100%;\n  padding: 10px;\n  margin: 5px 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-family: \"DM Sans\", sans-serif;\n}\n\n@media (max-width: 768px) {\n  input,\n  select,\n  textarea {\n    padding: 8px;\n    font-size: 16px;\n  }\n}\n\n/* Editores de texto enriquecido: el tema snow escribe a 13px, demasiado pequeño\n   para revisar una descripción. Las vistas con alto propio siguen mandando. */\n.ql-editor {\n  min-height: 130px;\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n/* Scrollbar personalizada */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n[role=\"dialog\"] {\n  max-width: calc(100vw - 24px);\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n/* Asegurar que los elementos flex sean responsivos */\n@media (max-width: 768px) {\n  [role=\"button\"] {\n    min-height: 44px;\n    min-width: 44px;\n  }\n}\n\n/* ---- Modo noche (Chakra pone body.chakra-ui-dark) ---------------------------------- */\n\n/* Campos de fecha, barras de desplazamiento y listas nativas en oscuro. */\nbody.chakra-ui-dark {\n  color-scheme: dark;\n}\n\nbody.chakra-ui-dark option {\n  color: #ffffff;\n  background-color: #111c44;\n}\n\nbody.chakra-ui-dark ::-webkit-scrollbar-thumb {\n  background: #3b4a7a;\n}\n\nbody.chakra-ui-dark ::-webkit-scrollbar-thumb:hover {\n  background: #4f5f94;\n}\n\n/* Editor de texto enriquecido (Quill, tema snow): iconos y bordes claros sobre oscuro. */\nbody.chakra-ui-dark .ql-toolbar.ql-snow,\nbody.chakra-ui-dark .ql-container.ql-snow {\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\nbody.chakra-ui-dark .ql-snow .ql-stroke {\n  stroke: #ffffff;\n}\n\nbody.chakra-ui-dark .ql-snow .ql-fill,\nbody.chakra-ui-dark .ql-snow .ql-stroke.ql-fill {\n  fill: #ffffff;\n}\n\nbody.chakra-ui-dark .ql-snow .ql-picker {\n  color: #ffffff;\n}\n\nbody.chakra-ui-dark .ql-snow .ql-picker-options {\n  background-color: #111c44;\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\nbody.chakra-ui-dark .ql-snow.ql-toolbar button:hover .ql-stroke,\nbody.chakra-ui-dark .ql-snow.ql-toolbar button.ql-active .ql-stroke,\nbody.chakra-ui-dark .ql-snow .ql-picker-label:hover .ql-stroke {\n  stroke: #ffffff;\n}\n\nbody.chakra-ui-dark .ql-editor.ql-blank::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
